import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import {
  INFINITE_NOTIFICATIONS_QUERY_KEY,
  NOTIFICATIONS_QUERY_KEY,
  useNotifications,
} from '@hooks/notifications';
import handleRequestError from '@utils/handleRequestError';

const MUTATION_KEY = [[NOTIFICATIONS_QUERY_KEY], [INFINITE_NOTIFICATIONS_QUERY_KEY]];

type UseNotificationCountsParams = {
  enabled?: boolean;
};

export function useNotificationCounts({ enabled = true }: UseNotificationCountsParams = {}) {
  const { pathname } = useLocation();

  const notifications = useNotifications({
    enabled,
    mutationKey: MUTATION_KEY,
    onError: handleRequestError,
  });
  const { refetchCounts } = notifications;

  const lastPathname = useRef(pathname);
  useEffect(() => {
    if (lastPathname.current === pathname) return;
    lastPathname.current = pathname;
    if (enabled) refetchCounts();
  }, [enabled, pathname, refetchCounts]);

  return notifications;
}
